import React from 'react';

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#000"
    height="24"
    width="24"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 24 24"
    style={{ verticalAlign: 'bottom' }}
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
      fill="#cd0000"
    />
    <path d="M11 17h2v-2h-2v2zm0-4h2V7h-2v6z" fill="#fff" />
  </svg>
);
